// biome-ignore lint/correctness/noUnusedImports: <explanation>
import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Typography } from '@cobliteam/ui/components';

import { Location } from '@cobliteam/common-types';

import { ReactComponent as PlaceholderNoAccess } from '../../assets/images/placeholder_no_access.svg';

interface AccessDeniedPanelProps {
  pageDescription: string;
}

const openPermissionsHelpPage = () => {
  const a = document.createElement('a');
  a.href = 'https://suporte.cobli.co/quais-permiss%C3%B5es-cada-fun%C3%A7%C3%A3o-tem-acesso';
  a.target = '_blank';
  a.click();
};

const AccessDeniedPanel = ({ pageDescription }: AccessDeniedPanelProps) => {
  return (
    <div className='my-10 flex w-full flex-col items-center justify-center'>
      <div className='flex flex-col items-center justify-center'>
        <PlaceholderNoAccess />
      </div>
      <div className='mt-10 flex flex-col items-center justify-center space-y-4 text-center'>
        <Typography variant='heading-2xl' className='font-bold' as='h1'>
          Ops... Parece que você está sem acesso.
        </Typography>
        <Typography variant='description-list-default'>
          Você está sem permissão para {pageDescription}.
          <br />
          Fale com o administrador da sua frota para conseguir acesso.
        </Typography>
        <br />
        <Link to={Location.HOME}>
          <Button>Voltar para o início</Button>
        </Link>
        <Button variant='text' color='default' onClick={openPermissionsHelpPage}>
          Saiba mais sobre permissões
        </Button>
      </div>
    </div>
  );
};

export default AccessDeniedPanel;
